import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import imageLogo from "../assest/img/xeni-logo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import apiService from "../services/apiService";

function VerifyOTP() {
  const location = useLocation();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [verificationMethod, setVerificationMethod] = useState(null);
  const [showOtpSection, setShowOtpSection] = useState(false);
  const navigate = useNavigate();
  // const { username } = location.state || {};

  const [username, setUsername] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Decode JWT to get user email
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded?.email) {
          setUserEmail(decoded.email); // Set user email from JWT
        }
        if (decoded?.username) {
          setUsername(decoded.username); // Set username from JWT
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    }
  }, []);

  const handleVerificationMethodChange = async (method) => {
    setVerificationMethod(method);
    setCode("");
    setMessage("");
    setMessageType("");
    setShowOtpSection(true);

    if (method === "email") {
      try {
        setIsSubmitting(true);
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authorization token is missing");
          return;
        }

        await apiService.post("/send-otp",
          { username },
        );

        setMessage(
          `Please check your email at ${userEmail} for the OTP code. Enter the code below to proceed`
        );
        setMessageType("info");
      } catch (error) {
        setMessage("Failed to send OTP. Please try again.");
        setMessageType("error");
      } finally {
        setIsSubmitting(false);
      }
    } else if (method === "authenticator") {
      setMessage("Enter the code from your Authenticator");
      setMessageType("info");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authorization token is missing");
        return;
      }

      const response = await apiService.post("/verify-totp",
        {
          code,
          userName: username,
          type: verificationMethod === "email" ? "email" : "totp",
        });

      if (response) {
        localStorage.setItem("token", response.data.token);
        setMessage("Verification successful!");
        setMessageType("success");
        setTimeout(() => navigate("/admin-panel"), 2000);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Verification failed. Please try again.";
      if (errorMessage.toLowerCase().includes("invalid")) {
        setMessage("Invalid code. Please try again.");
      } else {
        setMessage(errorMessage);
      }
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (verificationMethod) {
      setShowOtpSection(true);
    } else {
      setShowOtpSection(false);
    }
  }, [verificationMethod]);

  return (
    <div className="min-h-screen flex flex-col md:flex-row relative bg-gray-100">
      <ToastContainer />
      <div className="flex items-center justify-center w-full md:w-1/2">
        <img src={imageLogo} alt="Logo" className="w-2/3 sm:w-1/2" />
      </div>
      <div className="flex items-center justify-center w-full md:w-1/2">
        <div className="p-8 rounded-lg shadow-xl max-w-md w-full bg-gray-100 hover:scale-105">
          <h2
            className="text-2xl font-bold mb-6 text-center"
            style={{ color: "#225282" }}
          >
            Verify OTP
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-3">
              <label className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="verificationMethod"
                  value="authenticator"
                  checked={verificationMethod === "authenticator"}
                  onChange={(e) =>
                    handleVerificationMethodChange(e.target.value)
                  }
                  className="form-radio h-5 w-5 text-orange-500 border-gray-300 focus:ring-orange-500"
                />
                <span className="text-gray-700">
                  Verify using Authenticator
                </span>
              </label>
              <label className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="verificationMethod"
                  value="email"
                  checked={verificationMethod === "email"}
                  onChange={(e) =>
                    handleVerificationMethodChange(e.target.value)
                  }
                  className="form-radio h-5 w-5 text-orange-500 border-gray-300 focus:ring-orange-500"
                />
                <span className="text-gray-700">Verify using Email</span>
              </label>
            </div>

            {showOtpSection && (
              <div
                className={`transition-opacity duration-700 ${
                  showOtpSection ? "opacity-100" : "opacity-0"
                }`}
              >
                <div
                  className={`w-full p-3 rounded mb-4 ${
                    messageType === "success"
                      ? "bg-green-100 text-green-700"
                      : messageType === "error"
                      ? "bg-red-100 text-red-700"
                      : "bg-white text-gray-500"
                  }`}
                >
                  <p className="text-lg text-center">
                    {message ||
                      (verificationMethod === "authenticator"
                        ? "Enter the code from your Authenticator."
                        : `Please check your email at ${userEmail} for the OTP code. Enter the code below to proceed.`)}
                  </p>
                </div>

                <div className="mb-4">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="w-full p-3 border border-orange-500 rounded focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-500"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-orange-500 text-white p-3 rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors duration-500"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default VerifyOTP;
